import {RegDiv} from "../../../Components";

function CNTittle(){

    return (
       
        <RegDiv padding="2%" flexdirection="row" mobileflexdirection="column">
            <img src="../ACloud_Logo.ico" alt="ACloud POS icon " height="60px" width="80px"/> &nbsp; &nbsp; <h3 style={{ color: 'blue'}}>云峰收银  </h3>  
        </RegDiv>
 
  ); 
    
}

export default CNTittle;